import type { Point } from '@app/packages/geo/Point'

export function getPointArrayKey(loc: Point) {
  return [loc.lat, loc.lon].map(l => l.toFixed(5)).join(':')
}
